/**
 * Legacy ProgramApiService module — preserved as an empty AngularJS module
 * so existing dependencies (`acme.common.service.programApi`) keep resolving.
 *
 * The actual `ProgramApiService` is now exposed indirectly: the Angular 18
 * `ApiService` facade (registered as the downgraded `'ApiService'` in
 * apps/b2b-frontend/app/upgrade/ng-downgraded-components.ts) exposes
 * `apiService.program` as an `inject(ProgramApiService)` Angular 18 class.
 * The actual implementation lives at
 *   apps/b2b-frontend/app/core/api/program/program-api.service.ts
 *
 * Do NOT register `.service('ProgramApiService', ...)` here — nothing
 * consumes it directly anymore.
 */
angular.module('acme.common.service.programApi', [
  'acme.common.factory.apiVersion',
  'acme.common.factory.QueryStringBuilder',
]);
